import {
  Headline,
  MainContent,
  VideoHeader,
} from "../templates/common/Components.jsx";

import Container from "../templates/common/Container.jsx";
import LoggedInTemplate from "../templates/LoggedInTemplate.jsx";
import videoPlaceholder from "../img/daikin_placeholder_video@2x.png";

export default function Starligue() {
  return (
    <LoggedInTemplate title="Starligue Daikin">
      <VideoHeader video="/files/starligue.mp4" image={videoPlaceholder} />
      <MainContent>
        <Headline title="Starligue Daikin" big>
          Un nouvel air souffle sur la Starligue
        </Headline>
        <Container></Container>
      </MainContent>
    </LoggedInTemplate>
  );
}
